import {SnackbarProviderProps} from 'notistack'

const AUTO_HIDE_DURATION = 2500

export const SnackbarProps: SnackbarProviderProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  autoHideDuration: AUTO_HIDE_DURATION,
}
